<h1>Conexión Perdida</h1>
<p>Por favor espera, mientras restablecemos tu conexcion con un agente</p>
